/**
 * Scrolls to an element with the given ID smoothly.
 * @param id - The ID of the element to scroll to
 */
export function scrollToId(id: string): void {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

